import React, { useContext } from "react";
import { motion, AnimatePresence } from "motion/react"; // Framer Motion
import Modal from "./Modal";
import ModalContext from "../context/ModalContext";

const ModalRoot = () => {
    const modalContext = useContext(ModalContext);

    if (!modalContext.visible) {
        return null;
    }

    return <Modal {...modalContext.props}>{modalContext.content}</Modal>;
};

export default ModalRoot;
